import { render, staticRenderFns } from "./MentionSuggestionList.vue?vue&type=template&id=46e54776&scoped=true"
import script from "./MentionSuggestionList.vue?vue&type=script&lang=ts"
export * from "./MentionSuggestionList.vue?vue&type=script&lang=ts"
import style0 from "./MentionSuggestionList.vue?vue&type=style&index=0&id=46e54776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e54776",
  null
  
)

export default component.exports